import { key, notify } from '@databases/ping-registry';
import { createRowSelectionHandlePingEffect } from '@databases/selections';
import { getService } from '@databases/service-container';

import {
  SelectionFeatureKeys,
  type SelectionEffectFeature,
} from '../../features/types.ts';
import { isTimelineSelectionFeatureEnabled } from '../utils/is-timeline-selection-feature-enabled.ts';

export function createTimelineRowSelectionHandlePingEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.TIMELINE_ROW_SELECTION_HANDLE_PING_EFFECT,
    type: 'effect',
    isEnabled: isTimelineSelectionFeatureEnabled,
    factory: () =>
      createRowSelectionHandlePingEffect({
        resolveRowPositionToEntryId: (position) => {
          const selectionsApi = getService('SelectionsApi');

          return selectionsApi.resolvePositionToIds(position, 'row').entryId;
        },
        notifyRowSelectionChanged: (entryId) => {
          notify(key('row', { entryId }), 'selectionChanged', true);
        },
      }),
  };
}
